import React from 'react';
import PropTypes from 'prop-types';

const ButtonsContainer = ({ handleClose, handleSubmit, saveButtonDisabled }) => (
  <div className="button-container">
    <button
      className="button tertiary t-cancel-modal"
      onClick={() => handleClose()}
      type="button"
    >
      {t('Cancel')}
    </button>
    <button
      className="button primary t-confirm-modal"
      disabled={saveButtonDisabled}
      onClick={handleSubmit}
      type="button"
    >
      {t('Save Changes')}
    </button>
  </div>
);

ButtonsContainer.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  saveButtonDisabled: PropTypes.bool.isRequired,
};

export default ButtonsContainer;
